<template>
  <v-card
    class="ma-2 rounded-xl"
    :class="prop > min ? (prop > max ? 'is-red' : 'is-orange') : 'is-green'"
    flat
    outlined
    align="center"
  >
    <v-toolbar flat dense>
      <v-toolbar-title class="title ml-2 text--disabled">{{
        title
      }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-badge
        :color="prop > min ? (prop > max ? 'red' : 'orange') : 'green'"
        dot
        offset-x="15"
        offset-y="5"
      >
      </v-badge>
    </v-toolbar>
    <v-card-text class="pa-0">
      <v-row align="center" class="white--text text-no-wrap pa-4">
        <v-col class="text-h5 pa-0" cols="12">
          <span class="font-weight-medium">{{ prop }}</span
          ><small class="font-weight-light">{{ suffix }}</small>
        </v-col>
        <v-col cols="12" class="pa-0" v-if="maxVal > 0">
          <div>
            <v-icon v-if="title === 'Inside'" left small color="white"
              >far fa-sun</v-icon
            >
            <v-icon v-if="title === 'Outside'" left small color="white"
              >far fa-sun</v-icon
            >
            <v-icon v-if="title === 'Humidity'" left small color="white"
              >fas fa-arrow-up</v-icon
            >
            <v-icon v-if="title === 'Pressure'" left small color="white"
              >fas fa-arrow-up</v-icon
            >
            {{ maxVal }}{{ suffix }}
          </div>
          <div>
            <v-icon v-if="title === 'Inside'" left small color="white"
              >far fa-snowflake</v-icon
            >
            <v-icon v-if="title === 'Outside'" left small color="white"
              >far fa-snowflake</v-icon
            >
            <v-icon v-if="title === 'Humidity'" left small color="white"
              >fas fa-arrow-down</v-icon
            >
            <v-icon v-if="title === 'Pressure'" left small color="white"
              >fas fa-arrow-down</v-icon
            >
            {{ minVal }}{{ suffix }}
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "Dashboard",
  props: ["history", "prop", "title", "icon", "suffix", "min", "max"],
  data: () => ({
    maxVal: null,
    minVal: null,
  }),
  watch: {
    history: function() {
      this.fillData();
    },
  },
  mounted() {
    this.fillData();
  },
  methods: {
    fillData() {
      const data = new Array();

      if (this.history) {
        for (let index in this.history) {
          if (this.title === "Inside") {
            data.push(this.history[index].TempIn);
          } else if (this.title === "Outside") {
            data.push(this.history[index].TempOut);
          } else if (this.title === "Humidity") {
            data.push(this.history[index].Humidity);
          } else if (this.title === "Pressure") {
            data.push(this.history[index].Pressure);
          }
        }

        const array = data.slice(Math.max(data.length - 24, 0));

        this.maxVal = Math.max.apply(Math, array);
        this.minVal = Math.min.apply(Math, array);
        // this.history.forEach(res => {
        //   if (this.title === 'Inside') {
        //     data.push(Number(res.TempIn))
        //   }
        //   else if (this.title === 'Outside') {
        //     data.push(Number(res.Humidity))
        //   }
        // })
      }
    },
  },
};
</script>

<style scoped></style>
